export default {
    InstallerCompanyAdmin: "InstallerCompanyAdmin",
    InstallerCompanyUser: "InstallerCompanyUser",
    InstallerCompanyTechnician: "InstallerCompanyTechnician",
    Admin: "Admin",
    MasterAdmin: "MasterAdmin"
};
